export default __webpack_public_path__ + "static/media/IMG_5130cropped.4aa86452.jpeg";